import Util from "./Util.js";
import { gsap } from "./Util.js";

class Filter extends Util {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.filterForm = document.getElementById("product-filters");
    if (!this.filterForm) return;

    this.filterFunc();
  }

  filterFunc() {
    this.currentSortDiv = document.querySelector(".current-sort");
    this.applyFiltersButton = document.getElementById("apply-filters-btn");
    this.applyFiltersButtonText = this.applyFiltersButton ? this.applyFiltersButton.querySelector(".btn-text") : null;
    this.clearFiltersButton = document.getElementById("clear-filters-btn");
    this.clearFiltersButtonText = this.clearFiltersButton ? this.clearFiltersButton.querySelector(".btn-text") : null;
    this.sortByButtonsContainer = document.querySelector(".sort-by-buttons");
    this.productsGridElement = document.querySelector(".stay-list") || document.querySelector(".products-grid");
    this.productCountElement = document.querySelector(".product-count p");
    this.productCountBadgeElement = document.querySelector(".product-count b");

    this.btnOpen = document.querySelector(".btn-filter");
    this.btnClose = document.querySelector(".btn-close");
    this.bgClose = document.querySelector(".bg-close");
    this.filtersWrap = document.querySelector(".filters-wrap");

    // --- Configuration ---
    this.DEBOUNCE_DELAY = 500;

    // --- State ---
    this.debounceTimer = null; // 初期化

    // --- Expose to Global Shopify Object ---
    window.Shopify = window.Shopify || {};
    // bind(this) を使って、クラスメソッド内の this が Filter インスタンスを指すようにする
    window.Shopify.handleSortChange = this.handleSortChange.bind(this);
    window.Shopify.clearFilters = this.clearAllFilters.bind(this);

    this.initializeFiltersFromURL();
    this.bindEventListeners();
    this.updateProductCountOnButton(); // 初期表示の件数更新
    this.checkAndToggleApplyButtonVisibility();

    this.spEvent();
  }

  spEvent() {
    if (!this.website.isDesktop) {
      // <form id="product-filters" class="filter-wrap sp-h-fit" onwheel="event.stopPropagation()"></form>
    }

    this.btnOpen.addEventListener("click", () => {
      document.body.classList.toggle("is-filter-open");
    });
    this.bgClose.addEventListener("click", () => {
      document.body.classList.toggle("is-filter-open");
    });
    this.btnClose.addEventListener("click", () => {
      document.body.classList.toggle("is-filter-open");
    });
  }

  // --- Utility Functions ---
  updateURL(params) {
    const newRelativePathQuery = window.location.pathname + "?" + params.toString() + window.location.hash;
    window.history.replaceState({ path: newRelativePathQuery }, "", newRelativePathQuery);
  }

  async fetchAndParseHTML(url, options = {}) {
    const response = await fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest", ...options.headers },
      ...options,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const htmlString = await response.text();
    const parser = new DOMParser();
    return parser.parseFromString(htmlString, "text/html");
  }

  updateProductDisplay(doc) {
    // Stayページでは .stay-list を使用、フォールバックとして .products-grid も確認
    const newProductsGrid = doc.querySelector(".stay-list") || doc.querySelector(".products-grid");
    if (newProductsGrid && this.productsGridElement) {
      this.productsGridElement.innerHTML = newProductsGrid.innerHTML;
    } else if (this.productsGridElement) {
      this.productsGridElement.innerHTML = "<p>該当なし</p>";
    }

    // ページネーションの更新
    const newPagination = doc.querySelector(".pagination") || doc.querySelector("[data-pagination]");
    const currentPagination = document.querySelector(".pagination") || document.querySelector("[data-pagination]");
    if (newPagination && currentPagination) {
      currentPagination.outerHTML = newPagination.outerHTML;
    }

    const newProductCountText = doc.querySelector(".product-count p"); // section.product_count から p タグを取得
    if (newProductCountText && this.productCountElement) {
      this.productCountElement.textContent = newProductCountText.textContent;
    }

    const newProductCountBadge = doc.querySelector(".product-count b"); // 同様に b タグを取得
    if (newProductCountBadge && this.productCountBadgeElement) {
      this.productCountBadgeElement.textContent = newProductCountBadge.textContent;
    }

    // グローバルインスタンスが存在する場合のみ呼び出す
    if (window.MOUSE_INSTANCE && window.MOUSE_INSTANCE.events) {
      window.MOUSE_INSTANCE.events();
    }
    if (window.APP_INSTANCE && window.APP_INSTANCE.fadeOut) {
      window.APP_INSTANCE.fadeOut();
    }
    this.showContents();
  }

  setButtonLoadingState(button, buttonTextEl, isLoading, loadingText = "Loading...", originalText = "Submit") {
    if (!button || !buttonTextEl) return;
    button.disabled = isLoading;
    button.classList.toggle("loading", isLoading);
    buttonTextEl.textContent = isLoading ? loadingText : originalText;
  }

  // --- Sort Functions ---
  getActiveSortValue() {
    const activeButton = this.sortByButtonsContainer ? this.sortByButtonsContainer.querySelector(".sort-button.active") : null;
    return activeButton ? activeButton.dataset.sortBy : null;
  }

  updateSortButtonsUI(activeSortValue) {
    if (!this.sortByButtonsContainer) return;
    const buttons = this.sortByButtonsContainer.querySelectorAll(".sort-button");
    buttons.forEach((button) => {
      button.classList.toggle("active", button.dataset.sortBy === activeSortValue);
    });
    const sortByContainer = document.querySelector(".sort-by");
    if (sortByContainer) sortByContainer.classList.remove("is-open");
    const sortBySelect = document.getElementById("sort-by-select");
    if (sortBySelect) sortBySelect.value = activeSortValue || "";
  }

  updateCurrentSortDisplay() {
    if (!this.currentSortDiv || !this.sortByButtonsContainer) return;

    const activeButton = this.sortByButtonsContainer.querySelector(".sort-button.active");
    if (activeButton) {
      this.currentSortDiv.textContent = activeButton.textContent.trim();
      return;
    }

    // アクティブなボタンがない場合、デフォルトまたは最初のボタンを試みる
    let defaultSortValue = '{{ collection.default_sort_by | default: "" }}';
    defaultSortValue = defaultSortValue.startsWith("{{") ? "" : defaultSortValue; // Liquidが評価されなかった場合のフォールバック
    let buttonToDisplay = null;

    if (defaultSortValue) {
      // 空文字でなければ実行
      buttonToDisplay = this.sortByButtonsContainer.querySelector(`.sort-button[data-sort-by="${defaultSortValue}"]`);
    }

    if (!buttonToDisplay && this.sortByButtonsContainer.firstElementChild && this.sortByButtonsContainer.firstElementChild.classList.contains("sort-button")) {
      buttonToDisplay = this.sortByButtonsContainer.firstElementChild;
    }

    if (buttonToDisplay) {
      // 他にアクティブなボタンがなければ、このボタンをアクティブにする
      if (!this.sortByButtonsContainer.querySelector(".sort-button.active")) {
        buttonToDisplay.classList.add("active"); // UI更新
        const sortBySelect = document.getElementById("sort-by-select");
        if (sortBySelect) sortBySelect.value = buttonToDisplay.dataset.sortBy;
      }
      this.currentSortDiv.textContent = buttonToDisplay.textContent.trim();
    } else {
      this.currentSortDiv.textContent = "指定なし";
    }
  }

  // --- Filter Count Update ---
  async updateProductCountOnButton() {
    if (!this.applyFiltersButton || !this.applyFiltersButtonText) return;

    const formData = new FormData(this.filterForm);
    const params = new URLSearchParams();

    formData
      .getAll("constraint")
      .filter((val) => val) // 空の値をフィルタリング
      .forEach((val, index, arr) => {
        if (index === 0) params.set("constraint", val);
        else params.append("constraint", val);
      });
    if (params.has("constraint")) {
      // 複数のconstraintをカンマ区切りに
      const constraints = params.getAll("constraint");
      params.delete("constraint");
      params.set("constraint", constraints.join(","));
    }

    const fetchUrl = `${window.location.pathname}?${params.toString()}`;

    try {
      const doc = await this.fetchAndParseHTML(fetchUrl);
      // 件数表示は行わず、常に「Submit」を表示
      this.applyFiltersButtonText.textContent = "Submit";
    } catch (error) {
      console.error("取得エラー:", error);
      this.applyFiltersButtonText.textContent = "Submit";
    }
    this.checkAndToggleApplyButtonVisibility();
    // finallyブロックは、この関数では特にローディング状態を戻す必要がないため不要
  }

  handleFilterInputChange() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(this.updateProductCountOnButton.bind(this), this.DEBOUNCE_DELAY);
  }

  // --- Main Filter/Sort Actions ---
  async applyFilters() {
    if (!this.applyFiltersButton || !this.applyFiltersButtonText) return;

    this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, true, "Loading...");

    const formData = new FormData(this.filterForm);
    const params = new URLSearchParams(window.location.search); // 既存のパラメータを引き継ぐ

    // constraintパラメータの処理
    const constraintValues = formData.getAll("constraint").filter((val) => val);
    if (constraintValues.length > 0) {
      params.set("constraint", constraintValues.join(","));
    } else {
      params.delete("constraint");
    }

    const fetchUrl = `${window.location.pathname}?${params.toString()}`;

    try {
      this.hideContents();
      const doc = await this.fetchAndParseHTML(fetchUrl);
      this.updateProductDisplay(doc);
      this.updateURL(params);
      // ボタンのテキストと状態をここで最終的に設定（常に「Submit」を表示）
      this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, false, "Loading...", "Submit");
    } catch (error) {
      console.error("フィルター適用エラー:", error);
      this.setButtonLoadingState(this.applyFiltersButton, this.applyFiltersButtonText, false, "Loading...", "Submit");
    }
    this.checkAndToggleApplyButtonVisibility();
    // finally ブロックでの updateProductCountOnButton 呼び出しは削除 (二重 fetch となるため)
  }

  async handleSortChange(sortValue) {
    this.hideContents();

    const params = new URLSearchParams(window.location.search);
    if (sortValue) {
      params.set("sort_by", sortValue);
    } else {
      params.delete("sort_by");
    }

    this.updateSortButtonsUI(sortValue);

    const fetchUrl = `${window.location.pathname}?${params.toString()}`;

    try {
      const doc = await this.fetchAndParseHTML(fetchUrl);
      this.updateProductDisplay(doc);
      this.updateURL(params);
      this.updateCurrentSortDisplay();
    } catch (error) {
      console.error("ソート変更エラー:", error);
      if (this.productCountElement) this.productCountElement.textContent = "エラーが発生しました";
    } finally {
      this.showContents();
    }
  }

  async clearAllFilters() {
    this.hideContents();
    if (this.clearFiltersButton && this.clearFiltersButtonText) {
      this.setButtonLoadingState(this.clearFiltersButton, this.clearFiltersButtonText, true, "Loading...");
    }

    const fetchUrl = window.location.pathname; // ベースURLで取得
    const params = new URLSearchParams(); // パラメータをクリア

    try {
      const doc = await this.fetchAndParseHTML(fetchUrl);
      this.updateProductDisplay(doc);

      this.filterForm.reset();

      this.updateURL(params); // URLからクエリパラメータを削除

      // クリアボタンのテキストと状態をここで最終的に設定（常に「Clear」を表示）
      if (this.clearFiltersButton && this.clearFiltersButtonText) {
        this.setButtonLoadingState(this.clearFiltersButton, this.clearFiltersButtonText, false, "Loading...", "Clear");
      }
    } catch (error) {
      console.error("フィルタークリアエラー:", error);
      if (this.clearFiltersButton && this.clearFiltersButtonText) {
        this.setButtonLoadingState(this.clearFiltersButton, this.clearFiltersButtonText, false, "Loading...", "Clear");
      }
    } finally {
      if (this.productsGridElement) {
        gsap.to(this.productsGridElement, {
          opacity: 1,
          duration: 0.15,
          delay: 0.3,
          ease: "linear",
        });
      }
      this.checkAndToggleApplyButtonVisibility();
    }
  }

  // --- Initialization ---
  initializeFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);

    // タグフィルターの初期化
    const constraints = params.get("constraint");
    if (constraints) {
      constraints.split(",").forEach((tag) => {
        const checkbox = document.getElementById(`tag-${tag}`);
        if (checkbox) checkbox.checked = true;
      });
    }
  }

  bindEventListeners() {
    this.filterForm.addEventListener("submit", (event) => {
      event.preventDefault();
      this.applyFilters();
    });

    if (this.clearFiltersButton) {
      this.clearFiltersButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.clearAllFilters();
      });
    }

    const filterInputs = this.filterForm.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    filterInputs.forEach((input) => {
      input.addEventListener("change", this.handleFilterInputChange.bind(this));
    });
  }

  checkAndToggleApplyButtonVisibility() {
    if (!this.applyFiltersButton || !this.filterForm || !this.applyFiltersButtonText) return;

    const activeConstraintCheckboxes = this.filterForm.querySelectorAll('input[name="constraint"]:checked');
    const isAnyConstraintActive = activeConstraintCheckboxes.length > 0;

    // 制約フィルターのみを考慮
    const shouldHideButton = !isAnyConstraintActive;

    if (shouldHideButton) {
      this.applyFiltersButton.classList.add("none");
      this.applyFiltersButtonText.textContent = "Submit";
    } else {
      this.applyFiltersButton.classList.remove("none");
      // 常に「Submit」を表示
      this.applyFiltersButtonText.textContent = "Submit";
    }
  }

  hideContents() {
    if (this.productsGridElement) {
      gsap.to(this.productsGridElement, {
        opacity: 0,
        duration: 0.15,
        ease: "linear",
      });
    }
    if (this.filtersWrap) {
      this.filtersWrap.classList.remove("is-open");
    }
  }

  showContents() {
    if (this.productsGridElement) {
      gsap.to(this.productsGridElement, {
        opacity: 1,
        duration: 0.15,
        ease: "linear",
        delay: 0.3,
      });
    }
  }
}

export default Filter;
